/**
 * Warning emitted by Space survey validation rules.
 */
export interface Warning {
  /**
   * Stable warning identifier used by clients to route warning-specific UI.
   */
  code: Warning.Code
  /**
   * Human-readable warning text.
   */
  message: string
}

export namespace Warning {
  export enum Code {
    ExclusiveFunctionsForNonExclusiveMethodology = 'exclusiveFunctionsForNonExclusiveMethodology',
    InvalidFunctionalizationsForExclusiveMethodology = 'invalidFunctionalizationsForExclusiveMethodology',
    FunctionalUsageNotFullyCoded = 'functionalUsageNotFullyCoded',
    MissingFunctionalUsagesForSelectedAccounts = 'missingFunctionalUsagesForSelectedAccounts',
    MissingSponsoredAccountsForSponsoredFunctionalUsages = 'missingSponsoredAccountsForSponsoredFunctionalUsages',
  }
}
